import { render, staticRenderFns } from "./approvalsTab.vue?vue&type=template&id=fda79b60&scoped=true"
import script from "./approvalsTab.vue?vue&type=script&lang=js"
export * from "./approvalsTab.vue?vue&type=script&lang=js"
import style0 from "./approvalsTab.vue?vue&type=style&index=0&id=fda79b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda79b60",
  null
  
)

export default component.exports